import { Avatar } from 'flowbite-react';
import { Tooltip } from '@mui/material';
import React from 'react';
import { stringAvatar } from 'shared-utils';
import { DriveInviteeDocument, OfflineDriveCandidateStatus, OfflineDriveRoomDocument } from 'types';
import DisplayRoom from '../DisplayRoom';
import { FaCheckCircle } from 'react-icons/fa';
import dayjs from 'dayjs';

const CandidateProfileColumn = ({
	name,
	email,
	image,
	phone,
	status,
	handler,
	studentCode,
	offlineDriveRoom,
	showLink = false,
	documents,
	attendDriveDate,
}: {
	name: string;
	email: string;
	phone: string;
	image: string;
	handler: string;
	showLink?: boolean;
	studentCode: string;
	documents?: DriveInviteeDocument['documents'];
	status?: OfflineDriveCandidateStatus;
	offlineDriveRoom: OfflineDriveRoomDocument;
	attendDriveDate?: Date;
}) => {
	return (
		<div className="flex grow-2 gap-2 items-center">
			<div className="min-w-[80px] relative">
				<Avatar
					rounded
					size="lg"
					img={image || ''}
					className="text-xl"
					placeholderInitials={stringAvatar(name?.trim()?.toUpperCase() || email?.trim()?.toUpperCase())}
				/>
			</div>
			<div className="flex flex-col gap-1">
				<div className="flex items-center gap-1">
					<Tooltip title={name} placement="top">
						{showLink ? (
							<a
								target="_blank"
								href={`${process.env.REACT_APP_APP_ENDPOINT}/profile/${handler}?company=true`}
								className="cursor-pointer underline text-[18px] font-[600] text-[#1C1C28] flex items-center gap-1 capitalize"
							>
								<span>{name?.toLowerCase()}</span>
							</a>
						) : (
							<p className="text-[#1C1C28] font-inter text-lg font-semibold capitalize">{name?.toLowerCase()}</p>
						)}
					</Tooltip>
					{documents && documents?.filter(e => e?.isAdminVerified).length > 0 ? (
						<Tooltip
							title={documents
								?.filter(e => e?.isAdminVerified)
								?.map(document => document.documentType)
								.join(', ')}
							placement="top"
						>
							<div>
								<FaCheckCircle className="text-blue-500" />
							</div>
						</Tooltip>
					) : null}
				</div>
				<div className="flex flex-col gap-[3px]">
					<p className="text-[#28293D] font-inter text-xs font-medium">{email}</p>
					<p className="text-[#555770] text-xs font-medium">
						{phone} {studentCode ? `(${studentCode})` : ''}
					</p>
					<DisplayRoom offlineDriveRoom={offlineDriveRoom} status={status} />
					{attendDriveDate ? (
						<p className="text-[#28293D] font-inter text-xs font-medium">
							<span className="text-[#1C1C28] font-inter text-[12px] leading-[16px] font-[700]">Registered At: </span>
							{attendDriveDate ? dayjs(attendDriveDate).format('Do MMM YYYY, hh:mm A') : '-'}
						</p>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default CandidateProfileColumn;
